import { useBarcode } from 'next-barcode'

interface BarcodeProps {
    value: string,
    displayValue?: boolean
    format: string
    width?: number
    height?: number
    marginTop?: number
    marginBottom?: number
    fontSize?: number
}

const Barcode = (props: BarcodeProps): JSX.Element => {
  const {
    value, displayValue = false, format, width = 1.0, height = 30, marginTop = 2, marginBottom = 6, fontSize,
  } = props

  const { inputRef } = useBarcode({
    value,
    options: {
      displayValue,
      format,
      width,
      height,
      marginTop,
      marginBottom,
      fontSize,
    },
  })

  return <canvas ref={inputRef} />
}

export { Barcode }
